import {createLocalStorageRecentSearchesPlugin} from '@algolia/autocomplete-plugin-recent-searches';

export function getRecentSearchesPlugin(translations) {
    return createLocalStorageRecentSearchesPlugin({
        key: 'RECENT_SEARCH',
        limit: ACC.config.algolia.autocompleteRecentSearchesMax,
        transformSource({source}) {
            return {
                ...source,
                templates: {
                    ...source.templates,
                    header() {
                        return translations['algolia.search.autocomplete.header.recentsearch'];
                    },
                    footer() {
                        return '';
                    },
                },
                onSelect({setQuery, state}) {
                    setQuery(state.query);
                    $('.aa-SubmitButton').click();
                }
            };
        },
    });
}